import React from "react";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Sparkles, Phone, Mail, Globe, Instagram, MapPin, Pencil, Trash2 } from "lucide-react";
import { ScoreBadge } from "../Badges";
import { STAGES, probColor } from "../../lib/constants";

const igHref = (v) => (v.startsWith("http") ? v : `https://instagram.com/${v.replace("@", "")}`);
const siteHref = (v) => (v.startsWith("http") ? v : `https://${v}`);

export const DrawerHeader = ({ p, analyzing, onAnalyze, onStatus, onEdit, onRemove }) => (
  <div className="border-b border-border p-6">
    <div className="flex items-start justify-between gap-4">
      <div>
        <div className="mb-2 flex items-center gap-3">
          <ScoreBadge score={p.score} priority={p.priority} />
          {p.ai_analyzed && <span className="inline-flex items-center gap-1 text-xs text-primary"><Sparkles className="h-3 w-3" /> AI</span>}
          {p.acquisition?.probability != null && (
            <span className="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold tabular-nums"
              style={{ color: probColor(p.acquisition.probability), borderColor: probColor(p.acquisition.probability) + "66" }}
              data-testid="header-acq-probability">
              {p.acquisition.probability}% acquisizione
            </span>
          )}
        </div>
        <h2 className="font-heading text-2xl font-bold tracking-tight">{p.azienda}</h2>
        <div className="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-sm text-muted-foreground">
          {p.settore && <span>{p.settore}</span>}
          {p.citta && <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" />{p.citta}</span>}
          {p.referente && <span>· {p.referente}</span>}
        </div>
      </div>
      <div className="flex gap-1">
        <Button size="icon" variant="ghost" onClick={() => onEdit(p)} data-testid="edit-prospect-btn"><Pencil className="h-4 w-4" /></Button>
        <Button size="icon" variant="ghost" onClick={onRemove} data-testid="delete-prospect-btn"><Trash2 className="h-4 w-4 text-destructive" /></Button>
      </div>
    </div>

    <div className="mt-4 flex flex-wrap gap-2">
      {p.telefono && <Contact icon={Phone} text={p.telefono} href={`tel:${p.telefono}`} />}
      {p.email && <Contact icon={Mail} text={p.email} href={`mailto:${p.email}`} />}
      {p.sito && <Contact icon={Globe} text="Sito" href={siteHref(p.sito)} />}
      {p.instagram && <Contact icon={Instagram} text="Instagram" href={igHref(p.instagram)} />}
    </div>

    <div className="mt-4 flex items-center gap-3">
      <Button onClick={onAnalyze} disabled={analyzing} className="flex-1" data-testid="analyze-btn">
        <Sparkles className="mr-2 h-4 w-4" />
        {analyzing ? "Analisi in corso..." : p.ai_analyzed ? "Ri-analizza con AI" : "Analizza con AI"}
      </Button>
      <Select value={p.status} onValueChange={onStatus}>
        <SelectTrigger className="w-44" data-testid="drawer-status-select"><SelectValue /></SelectTrigger>
        <SelectContent>{STAGES.map((s) => <SelectItem key={s.key} value={s.key}>{s.label}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  </div>
);

function Contact({ icon: Icon, text, href }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-lg border border-border bg-secondary/40 px-2.5 py-1.5 text-xs transition-colors hover:border-primary/40 hover:text-primary">
      <Icon className="h-3.5 w-3.5" /> {text}
    </a>
  );
}
